import { render, staticRenderFns } from "./AreaMediaModal.vue?vue&type=template&id=51c8619e"
import script from "./AreaMediaModal.vue?vue&type=script&lang=js"
export * from "./AreaMediaModal.vue?vue&type=script&lang=js"
import style0 from "./AreaMediaModal.vue?vue&type=style&index=0&id=51c8619e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports